import { render } from "./NCheckbox.vue?vue&type=template&id=5593bf3f&ts=true"
import script from "./NCheckbox.vue?vue&type=script&lang=ts"
export * from "./NCheckbox.vue?vue&type=script&lang=ts"

import "./NCheckbox.vue?vue&type=style&index=0&id=5593bf3f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__